import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import burgerImg from '../../../images/burger-menu.svg';
//
import Container from '../Container';
import Link from '../Link';
import PromoLink from '../PromoLink';

const navBreakpoint = 960;

// * Wrapper for the whole header
export const StyledHeader = styled.header`
  // * Need a z-index here as the header needs to be overtop the menu overlay but below the hubspot overlay
  z-index: 75;
  background-color: ${themeGet('colors.white')};
  box-shadow: 0 0 6px 0 ${themeGet('colors.grey')};
  position: sticky;
  top: 0;
`;

// * This is an inner wrapper for the header (Can psosibly be merged into the styled header)
export const Wrapper = styled(Container)`
  display: flex;
  align-items: stretch;
  padding: 6px 0;

  > a {
    align-self: center;
  }

  @media only screen and (min-width: ${navBreakpoint + 1}px) {
    padding: 0;
  }
`;

export const LogoLink = styled(Link)`
  &:hover,
  &:focus {
    opacity: 1 !important;
  }
`;

// * Styles for the logo
export const Logo = styled.img`
  width: 100%;
  width: 98px;

  @media only screen and (min-width: ${themeGet('breakpoints.ml')}) {
    margin-right: 5px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    height: 100%;
    width: 116px;
    margin-right: 10px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    margin-right: 50px;
  }
`;

// * Menu That holds all the dropdowns
export const Menu = styled.ul`
  padding: 0 0 25px;

  && {
    margin-bottom: auto;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.ml')}) {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 0;

    && {
      margin-right: auto;
      margin-bottom: 0;
    }

    li {
      height: 100%;
    }
  }
`;

// * Login link
export const Login = styled(PromoLink)`
  font-family: ${themeGet('fonts.primary')};
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.5px;
  line-height: 21px;
  border: none;
  white-space: nowrap;

  margin: auto 35px auto auto;

  &::before {
    content: '';
    position: absolute;
    /* bottom: -6px; */
    bottom: 0;
    display: block;
    width: 100%;
    max-width: 52px;
    height: 0%;
    max-height: 3px;
    background-color: ${themeGet('colors.orange')};
    transition: height 300ms;
  }

  &:hover,
  &:focus {
    border: none;
    color: ${themeGet('colors.text-secondary')};

    &::before {
      height: 100%;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.ml')}) {
    margin: auto 10px auto 25px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: auto 35px;
  }
`;

// * The "Play The Game" button
export const Play = styled(PromoLink)`
  white-space: nowrap;

  margin-top: 15px;
  @media only screen and (min-width: ${themeGet('breakpoints.ml')}) {
    margin: 6px 25px;
  }
`;

// * Button that opens the blade menu
export const MenuButton = styled.button`
  background-image: url(${burgerImg});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  margin: auto 0;
  height: 22px;
  width: 28px;
`;

export const Overlay = styled.div`
  position: fixed;
  z-index: 50;
  width: 100%;
  height: 100%;
  /* background: rgba(0, 0, 0, 0.3) none repeat scroll 0% 0%; */
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transition: opacity 0.3s ease 0s;
  transition: ${({ isOpen }) =>
    isOpen
      ? 'opacity 0.3s ease 0s'
      : 'opacity 0.3s ease 0s, transform 0s ease 0.3s'};
  transform: ${({ isOpen }) => (isOpen ? '' : 'translate3d(100%, 0px, 0px)')};
  top: 0px;
  left: 0px;
  right: 0px;
`;
